
import {Grid,Container} from '@mui/material';
import './pages.css';
import BigButton from '../components/bigbutton';
import ReactTypingEffect from 'react-typing-effect';
import { Link } from 'react-router-dom';

function Homepage() {

    return (
      <Container sx={{ width: '100%', height: '100%' }} maxWidth="lg"> 
        <Grid container spacing={2}>
            <Grid item xs={12} marginBottom={10}></Grid>
            <Grid item xs={12} className='jumbotron'>
                <ReactTypingEffect
                    text={["Selamat Datang!","Welcome!","ようこそ!","مَرْحَبًا"]}
                    speed={100}
                    className='Homepage-title'
                    eraseSpeed={50}
                    eraseDelay={3000}
                />
            </Grid>
            <Grid item xs={12} marginBottom={10}></Grid>
            <Grid container item xs={12} md={6} justifyContent="center">
                <Link to='/project' style={{textDecoration: 'none'}}><BigButton content='Project' color='#6fc2ff'/></Link>
            </Grid>
            <Grid container item xs={12} md={6} justifyContent="center">
                <Link to='/blog' style={{textDecoration: 'none'}}><BigButton content='Blogs' color='#ffde00'/></Link>
            </Grid>
        </Grid>
      </Container>
    )
}

export default Homepage